import { getRenderer } from "@/components/component.store";
import { CLASS_CONSTANTS } from "@/utils/constants";
import { Attachment } from "./Attachment";
import { entries } from "@/utils/object";

const DefaultAttachments = (props: { attachments: Record<string, string> }) => {
  const attachments = entries(props.attachments).map(([key, url]) => {
    const type = key.endsWith("pdf") ? "pdf" : "attachment";
    return <Attachment key={key} type={type} url={url} name={key} />;
  });

  return (
    <div className={CLASS_CONSTANTS.MESSAGE.ATTACHMENTS}>{attachments}</div>
  );
};

export const Attachments = getRenderer("Attachments", DefaultAttachments);
